import { render, staticRenderFns } from "./fccBancos.vue?vue&type=template&id=0bf7e639"
import script from "./fccBancos.vue?vue&type=script&lang=js"
export * from "./fccBancos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports